import axios from "../../../lib/axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import { TResponse, TResponseWithQData } from "../../../types/common";
import { QData } from "../../../types/basic-type-list";
import { IAdminOrder, IAdminOrderDetail, OrderStatusType, PaymentStatusType } from "../../../types/api/order";

export const getAdminOrderList = async (params: QData & { paymentStatus?: string; orderStatus?: string }) => {
  return await axios.get<TResponseWithQData<IAdminOrder[]>>(API_ENDPOINTS.ORDER_LIST, {
    params,
  });
};

export const getAdminOrderDetail = async (id: string) => {
  return await axios.get<TResponse<IAdminOrderDetail>>(`${API_ENDPOINTS.ORDER_DETAIL}/${id}`);
};

export const updateOrderStatusApi = async (id: string, payload: { status: OrderStatusType; comment?: string }) => {
  return await axios.put<TResponse<IAdminOrder>>(`${API_ENDPOINTS.ORDER_UPDATE_STATUS}/${id}`, payload);
};

export const updateOrderPaymentStatusApi = async (id: string, payload: { paymentStatus: PaymentStatusType }) => {
  return await axios.put<TResponse<IAdminOrder>>(`${API_ENDPOINTS.ORDER_UPDATE_PAYMENT_STATUS}/${id}`, payload);
};
